module.exports = __webpack_public_path__ + "static/crew-dashboard-60220d6830d599315d262eb505c0a642.png";